<template>
  <div class="row">
    <CheckboxFilter
      v-bind:options="productFilters"
      label="Filtra e cerca il Casinò"
      name="products"
    />

    <SelectFilter
      v-bind:options="softwareFilters"
      label="Software"
      name="softwares"
    />

    <SelectFilter v-bind:options="gameFilters" label="Giochi" name="games" />

    <SelectFilter
      v-bind:options="liveGameFilters"
      label="Giochi Live"
      name="games_live"
    />

    <SelectFilter
      v-bind:options="paymentFilters"
      label="Sistemi di prelievo"
      name="payments"
    />

    <SlideFilter
      name="bonus_massimo"
      label="Bonus di Benvenuto"
      v-bind:min="0"
      v-bind:max="1000"
    />
    <SlideFilter
      name="playthrough"
      label="Playthrough"
      v-bind:min="0"
      v-bind:max="160"
    />
    <SlideFilter
      name="puntata_minima_giochi_live"
      label="Puntata min. giochi live"
      v-bind:min="0"
      v-bind:max="1"
      v-bind:interval="0.01"
    />
    <SlideFilter
      name="puntata_minima_giochi_classici"
      label="Puntata min. giochi classici"
      v-bind:min="0"
      v-bind:max="1"
      v-bind:interval="0.01"
    />
    
      <div class="col-12 col-sm-2 text-center text-sm-right ml-auto mt-3">
<a class="btn btn-sm btn-block btn-primary" href="/risultati-motore-ricerca" v-if="onlyFilters">Cerca casinò</a>
      </div>
  </div>

</template>

<script>
import CheckboxFilter from './CheckboxFilter';
import SelectFilter from './SelectFilter';
import SlideFilter from './SlideFilter';

export default {
  name: 'CasinoFilters',
  components: {
    CheckboxFilter,
    SelectFilter,
    SlideFilter,
  },
  data: () => {
    return {
      onlyFilters : window.onlyFilters,
      productFilters: [
        { name: 'Casinò', value: 1 },
        { name: 'Sport', value: 2 },
        { name: 'Poker', value: 3 },
        { name: 'Bingo', value: 4 },
        { name: 'Ippica', value: 5 },
        { name: 'Corse virtuali', value: 6 },
        { name: 'Lotteria', value: 7 },
        { name: 'Skill Games', value: 8 },
      ],

      softwareFilters: JSON.parse(`[
  {
    "code": 1,
    "label": "Microgaming",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Microgaming.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Microgaming.png",
    "link_recensione": "/elenco-casino/microgaming",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 2,
    "label": "Playtech",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/playtech.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/playtech.png",
    "link_recensione": "/elenco-casino/playtech",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 3,
    "label": "Netent",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/netent.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/netent.png",
    "link_recensione": "/elenco-casino/netent",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 4,
    "label": "Novomatic",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/novomatic.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/novomatic.png",
    "link_recensione": "/elenco-casino/novomatic",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 5,
    "label": "iSoftBet",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/isoftbet.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/isoftbet.png",
    "link_recensione": "/elenco-casino/isoftbet",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 6,
    "label": "888",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/888.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/888.png",
    "link_recensione": "/elenco-casino/888",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 7,
    "label": "Gamesys",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Gamesys.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Gamesys.png",
    "link_recensione": "/elenco-casino/gamesys",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 8,
    "label": "GAN",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Gan.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Gan.png",
    "link_recensione": "/elenco-casino/gameaccount-network",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 9,
    "label": "Neogames",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Neogames.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Neogames.png",
    "link_recensione": "/elenco-casino/neogames",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 10,
    "label": "Capecod",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Capecod.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Capecod.png",
    "link_recensione": "/elenco-casino/capecod",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 11,
    "label": "Ainsworth",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Ainsworth.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Ainsworth.png",
    "link_recensione": "/elenco-casino/ainsworth",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 12,
    "label": "Amaya",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Amaya.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Amaya.png",
    "link_recensione": "/elenco-casino/amaya",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 13,
    "label": "Aristocrat",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Aristocrat.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Aristocrat.png",
    "link_recensione": "/elenco-casino/aristocrat",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 14,
    "label": "Bally",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Bally.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Bally.png",
    "link_recensione": "/elenco-casino/bally",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 15,
    "label": "Barcrest",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Barcrest.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Barcrest.png",
    "link_recensione": "/elenco-casino/barcrest",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 16,
    "label": "Nextgen",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Game360.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Game360.png",
    "link_recensione": "/elenco-casino/nextgen",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 17,
    "label": "Gamomat",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Gamomat.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Gamomat.png",
    "link_recensione": "/elenco-casino/gamomat",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 18,
    "label": "Giocaonline",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Giocaonline.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Giocaonline.png",
    "link_recensione": "/elenco-casino/giocaonline",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 19,
    "label": "IGT",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/igt.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/igt.png",
    "link_recensione": "/elenco-casino/igt",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 20,
    "label": "Incredible Technology",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/inctec.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/inctec.png",
    "link_recensione": "/elenco-casino/incredible-technology",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 21,
    "label": "Konami",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Konami.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Konami.png",
    "link_recensione": "/elenco-casino/konami",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 22,
    "label": "Mag",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Mag.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Mag.png",
    "link_recensione": "/elenco-casino/mag",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 23,
    "label": "MultiMedia Games",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Multimediagames.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Multimediagames.png",
    "link_recensione": "/elenco-casino/multimedia-games",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 24,
    "label": "Play'n Go",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Playngo.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Playngo.png",
    "link_recensione": "/elenco-casino/play-n-go",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 25,
    "label": "Reel Time Gamin",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Reeltimegaming.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Reeltimegaming.png",
    "link_recensione": "/elenco-casino/reel-time-gaming",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 26,
    "label": "World Match",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Worldmatch.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Worldmatch.png",
    "link_recensione": "/elenco-casino/world-match",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 27,
    "label": "NyX",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Nyx.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Nyx.png",
    "link_recensione": "/elenco-casino/nix",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 28,
    "label": "Betsoft",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/BetSoft.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/BetSoft.png",
    "link_recensione": "/elenco-casino/betsoft",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 29,
    "label": "1x2gaming",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/1x2Gaming.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/1x2Gaming.png",
    "link_recensione": "/elenco-casino/1x2gaming",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 30,
    "label": "Medialive",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/medialive.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/medialive.png",
    "link_recensione": "/elenco-casino/medialive",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 31,
    "label": "Tuko",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/tuko.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/tuko.png",
    "link_recensione": "/elenco-casino/tuko",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 32,
    "label": "Btg",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/btg.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/btg.png",
    "link_recensione": "/elenco-casino/big-time-gaming",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 33,
    "label": "Chance",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/chance.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/chance.png",
    "link_recensione": "/elenco-casino/chance-interactive",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 34,
    "label": "Evolution Gaming",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/evolution-g.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/evolution-g.png",
    "link_recensione": "/elenco-casino/evolution-gaming",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 35,
    "label": "Foxium",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/foxium.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/foxium.png",
    "link_recensione": "/elenco-casino/foxium",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 36,
    "label": "gameart",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/gameart.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/gameart.png",
    "link_recensione": "/elenco-casino/gameart",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 37,
    "label": "Gamelab",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/gamelab.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/gamelab.png",
    "link_recensione": "/elenco-casino/games-lab",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 38,
    "label": "Gamevy",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/gamevy.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/gamevy.png",
    "link_recensione": "/elenco-casino/gamevy",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 39,
    "label": "Inspired",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/inspired.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/inspired.png",
    "link_recensione": "/elenco-casino/inspired",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 40,
    "label": "Lighting-box",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/lighting-box.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/lighting-box.png",
    "link_recensione": "/elenco-casino/lightning-box",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 41,
    "label": "Playson",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/playson.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/playson.png",
    "link_recensione": "/elenco-casino/playson",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 42,
    "label": "Pragmatic Play",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/pragmatic.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/pragmatic.png",
    "link_recensione": "/elenco-casino/pragmatic-play",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 43,
    "label": "Scientific",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/scientific.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/scientific.png",
    "link_recensione": "/elenco-casino/scientific-games",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 44,
    "label": "Thunderkick",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/thunderkick.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/thunderkick.png",
    "link_recensione": "/elenco-casino/thunderkick",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 45,
    "label": "Iron Dog",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/iron-dog.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/iron-dog.png",
    "link_recensione": "/elenco-casino/iron-dog",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 46,
    "label": "Side city",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Side-City.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Side-City.png",
    "link_recensione": "/elenco-casino/side-city",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 47,
    "label": "Bet Digital",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Bet-Digital.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Bet-Digital.png",
    "link_recensione": "/elenco-casino/bet-digital",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 48,
    "label": "Edict",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/edict.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/edict.png",
    "link_recensione": "/elenco-casino/edict",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 49,
    "label": "Lucky Streak",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/lucky-streak.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/lucky-streak.png",
    "link_recensione": "/elenco-casino/lucky-streak",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 50,
    "label": "Yggdrasil",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/yggdrasil.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/yggdrasil.png",
    "link_recensione": "/elenco-casino/yggdrasil",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 51,
    "label": "Bwin-party",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/BwinParty.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/BwinParty.png",
    "link_recensione": "/elenco-casino/bwinparty",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 52,
    "label": "Mag elettronica",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/Mag.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/Mag.png",
    "link_recensione": "/elenco-casino/mag",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 53,
    "label": "SG Digital",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/sg-digital.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/sg-digital.png",
    "link_recensione": "/elenco-casino/sg-digital",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 54,
    "label": "Leander",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/leander.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/leander.png",
    "link_recensione": "/elenco-casino/leander",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 55,
    "label": "Booming",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/booming.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/booming.png",
    "link_recensione": "/elenco-casino/booming",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 56,
    "label": "Portomaso",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/portomaso.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/portomaso.png",
    "link_recensione": "/elenco-casino/portomaso",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 57,
    "label": "Habanero",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/habanero.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/habanero.png",
    "link_recensione": "/elenco-casino/habanero",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 58,
    "label": "Espresso Games",
    "logo": "https://cdn1.casino2k.com/images/static/sw/big/espresso.png",
    "logo_50": "https://cdn1.casino2k.com/images/static/sw/big/espresso.png",
    "link_recensione": "/elenco-casino/espresso-games",
    "updated_at": "2020-11-12 07:55:47",
    "created_at": "2020-11-12 07:56:12"
  },
  {
    "code": 59,
    "label": "gameaccount network",
    "logo": "",
    "logo_50": "",
    "link_recensione": "/elenco-casino/gameaccount-network",
    "updated_at": "2020-11-12 06:56:16",
    "created_at": "2020-11-12 06:56:16"
  },
  {
    "code": 60,
    "label": "game360 nextgen",
    "logo": "",
    "logo_50": "",
    "link_recensione": "/elenco-casino/nextgen",
    "updated_at": "2020-11-12 06:56:16",
    "created_at": "2020-11-12 06:56:16"
  }
]`),
      gameFilters: [
        { label: 'Blackjack', code: 1 },
        { label: 'Roulette', code: 2 },
        { label: 'Baccarat', code: 3 },
        { label: 'Videopoker', code: 4 },
      ],
      liveGameFilters: JSON.parse(`[
  {
    "code": 1,
    "label": "blackjack"
  },
  {
    "code": 2,
    "label": "roulette"
  },
  {
    "code": 3,
    "label": "baccarat"
  },
  {
    "code": 4,
    "label": "casino holdem"
  },
  {
    "code": 5,
    "label": "ultimate poker"
  },
  {
    "code": 6,
    "label": "3 card poker"
  },
  {
    "code": 7,
    "label": "caribbean"
  },
  {
    "code": 8,
    "label": "Dream catcher"
  },
  {
    "code": 9,
    "label": "Football Studio"
  },
  {
    "code": 10,
    "label": "Dragon Tiger"
  },
  {
    "code": 11,
    "label": "Super Sic Bo"
  },
  {
    "code": 12,
    "label": "Deal or no Deal"
  },
  {
    "code": 13,
    "label": "Monopoly"
  },
  {
    "code": 14,
    "label": "Side bet City"
  },
  {
    "code": 15,
    "label": "Dadi"
  },
  {
    "code": 16,
    "label": "Battaglia di dadi"
  },
  {
    "code": 17,
    "label": "Guerra"
  },
  {
    "code": 18,
    "label": "Lighting dice"
  },
  {
    "code": 19,
    "label": "Bets on poker"
  }
]`),
      paymentFilters: JSON.parse(`[
  {
    "code": 1,
    "label": "Paypal",
    "logo_50": "https://www.casino2k.com/images/static/pagamenti/paypal.png",
    "created_at": "2020-10-19 11:03:24",
    "updated_at": "2020-10-19 11:03:24"
  },
  {
    "code": 2,
    "label": "Postepay",
    "logo_50": "https://www.casino2k.com/images/static/pagamenti/postepay.png",
    "created_at": "2020-10-19 11:03:24",
    "updated_at": "2020-10-19 11:03:24"
  },
  {
    "code": 3,
    "label": "Neteller",
    "logo_50": "https://www.casino2k.com/images/static/pagamenti/neteller.png",
    "created_at": "2020-10-19 11:03:24",
    "updated_at": "2020-10-19 11:03:24"
  },
  {
    "code": 4,
    "label": "Skrill",
    "logo_50": "https://www.casino2k.com/images/static/pagamenti/skrill.png",
    "created_at": "2020-10-19 11:03:24",
    "updated_at": "2020-10-19 11:03:24"
  },
  {
    "code": 5,
    "label": "Paysafecard",
    "logo_50": "https://www.casino2k.com/images/static/pagamenti/psafecar.png",
    "created_at": "2020-10-19 11:03:24",
    "updated_at": "2020-10-19 11:03:24"
  },
  {
    "code": 6,
    "label": "Bonifico",
    "logo_50": "https://www.casino2k.com/images/static/pagamenti/bonifico.png",
    "created_at": "2020-10-19 11:03:24",
    "updated_at": "2020-10-19 11:03:24"
  },
  {
    "code": 7,
    "label": "Visa",
    "logo_50": "https://www.casino2k.com/images/static/pagamenti/visa.png",
    "created_at": "2020-10-19 11:03:24",
    "updated_at": "2020-10-19 11:03:24"
  },
  {
    "code": 8,
    "label": "Mastercard",
    "logo_50": "https://www.casino2k.com/images/static/pagamenti/mastcard.png",
    "created_at": "2020-10-19 11:03:24",
    "updated_at": "2020-10-19 11:03:24"
  },
  {
    "code": 9,
    "label": "Amex",
    "logo_50": "https://www.casino2k.com/images/static/pagamenti/aexpress.png",
    "created_at": "2020-10-19 11:03:24",
    "updated_at": "2020-10-19 11:03:24"
  },
  {
    "code": 10,
    "label": "Maestro",
    "logo_50": "https://www.casino2k.com/images/static/pagamenti/maestro.png",
    "created_at": "2020-10-19 11:03:24",
    "updated_at": "2020-10-19 11:03:24"
  },
  {
    "code": 11,
    "label": "Carte Debito",
    "logo_50": "https://www.casino2k.com/images/static/pagamenti/cdebito.png",
    "created_at": "2020-10-19 11:03:24",
    "updated_at": "2020-10-19 11:03:24"
  },
  {
    "code": 12,
    "label": "Assegno",
    "logo_50": "https://www.casino2k.com/images/static/pagamenti/assegno.png",
    "created_at": "2020-10-19 11:03:24",
    "updated_at": "2020-10-19 11:03:24"
  },
  {
    "code": 13,
    "label": "EcoPayz",
    "logo_50": "https://static.casino2k.com/pagamenti/ecopayz.jpg",
    "created_at": "2020-11-12 08:28:32",
    "updated_at": "2020-11-12 08:28:32"
  }
]`),
      bonusFilters: [
        { label: 'Bonus 1', code: 1 },
        { label: 'Bonus 2', code: 2 },
        { label: 'Bonus 3', code: 3 },
        { label: 'Bonus 4', code: 4 },
      ],
    };
  },
};
</script>
